import React from "react";
import { Col, Row } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import CustomCheckBox from "../../../../../../common/custom-checkbox/custom-checkbox";
import CustomDatepicker from "../../../../../../common/input/custom-datepicker/custom-datepicker";

const StudentDeclarationForm = ({ control }) => {
  return (
    <Row gutter={[32, 20]}>
      <Col span={24}>
        <Controller
          name="declaration"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomCheckBox
              id="declaration"
              label="I confirm that the above information is accurate."
              checked={value}
              onChange={(e) => onChange(e.target.checked)}
              errorMessage={error?.message}
            />
          )}
        />
      </Col>

      <Col span={24}>
        <Controller
          name="consent"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomCheckBox
              id="consent"
              label="I accept the terms and conditions of the school."
              checked={value}
              onChange={(e) => onChange(e.target.checked)}
              errorMessage={error?.message}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="signature"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="signature"
              label="Enter Full Name As Signature"
              showRequired
              labelColor="#171717"
              placeholder="Enter full name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="date"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomDatepicker
              id="date"
              label="Date"
              showRequired
              labelColor="#171717"
              placeholder="DD-MM-YYYY"
              size="large"
              value={value}
              onChange={onChange}
              style={{ height: "40px", width: "100%" }}
              status={error ? "error" : ""}
              prefix={
                <img
                  src="/assets/images/calendarOutlined.svg"
                  style={{ marginRight: 4 }}
                  alt="calendar"
                />
              }
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default StudentDeclarationForm;